@if (initialized && kpiHeaderDto) {

    <kpi-header [itemsArray]="kpiHeaderDto" [breadcrumb]="items" configRoute="/im/navigation-config"
    ></kpi-header>


}